// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_9RH","cls2":"LoggedOutDiscoveryPage-cls2_gu6 LoggedOutDiscoveryPage-cls1_9RH"};